import Icon from '../components/Icon.vue'

Icon.register({
  'hand-point-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 199.7c0 23.6-20.7 43.8-44.8 43.8h-99.9c16.3 17 18.3 49.8-6.3 70.9 14.3 22.8 2.1 53-16.5 62.3 9 49.1-21.9 71.3-72.6 71.3-2.7 0-13.3-0.2-16-0.2-62 0.2-76.9-31.1-123.7-38.3-11.7-1.8-20.3-11.9-20.3-23.7v-171.5l0 0c0-18.4 10.6-35.9 28.5-43.8 28.9-13 95.4-49 107.5-77.3 7.8-18.2 21.4-29.1 40-29.1 34.2 0 57.8 35.1 44.1 66.9-3.6 8.4-8.3 16.7-14.2 24.9h149.2c23.5 0 44.8 20.5 44.8 43.8zM96 200v192c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-192c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24zM68 368c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z'
      }
    ]
  }
})
